/* global globalThis */

export const KINDS = { client: 'Клиентский проект', personal: 'Свой проект', support: 'Поддержка', other: 'Другое' };
export const STATUSES = { planned: 'Ожидается', partial: 'Частично', paid: 'Оплачено', overdue: 'Просрочено', tentative: 'Возможно', cancelled: 'Отменено' };
export const STATUS_COLORS = { planned: 'primary', partial: 'primary', paid: 'success', overdue: 'danger', tentative: 'warning', cancelled: 'neutral' };
export const FREQUENCIES = { weekly: 'Каждую неделю', monthly: 'Каждый месяц', quarterly: 'Каждый квартал', yearly: 'Каждый год' };
export const COLORS = ['#686DF3', '#A679D9', '#449C87', '#E39A4B', '#E0799B', '#5197D5'];
export const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
export function money(value, currency = 'RUB', compact = false) {
  return new Intl.NumberFormat('ru-RU', { style: 'currency', currency, maximumFractionDigits: compact ? 0 : 2, minimumFractionDigits: 0 }).format(Number(value || 0));
}
export function shortDate(value) {
  if (!value) return '—';
  return new Date(`${value}T12:00:00`).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
}
export function monthLabel(value, short = false) {
  return new Date(`${value}-01T12:00:00`).toLocaleDateString('ru-RU', { month: short ? 'short' : 'long', ...(short ? {} : { year: 'numeric' }) });
}
export function shiftMonth(value, delta) {
  const [year, month] = value.split('-').map(Number);
  const d = new Date(year, month - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}
export function errorText(error) {
  const data = error.response?.data;
  if (!data || typeof data !== 'object' || data instanceof Blob) return 'Не удалось выполнить действие. Проверьте соединение и попробуйте снова.';
  const flatten = (v) => typeof v === 'string' ? v : Array.isArray(v) ? v.map(flatten).join(' ') : Object.values(v || {}).map(flatten).join(' ');
  return flatten(data) || 'Не удалось выполнить действие.';
}
export function requestKey() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  // crypto.getRandomValues also works on older browsers without randomUUID.
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const s = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${s.slice(0, 8)}-${s.slice(8, 12)}-${s.slice(12, 16)}-${s.slice(16, 20)}-${s.slice(20)}`;
}
